<ng-container *transloco="let t">
  @let m = mismatch();
  <ejs-dialog
    [isModal]="true"
    [visible]="true"
    [header]="t('Organization changed')"
    [showCloseIcon]="false"
    [closeOnEscape]="false"
    [width]="'480px'"
  >
    <ng-template #content>
      <div class="dialog-body">
        <p>{{ t('organizationChangedTo', { next: m.next.name }) }}</p>
        @if (m.previous) {
          <p>{{ t('organizationStayOrSwitch', { previous: m.previous.name }) }}</p>
        }
      </div>
    </ng-template>
    <ng-template #footerTemplate>
      <div class="actions">
        @if (m.previous) {
          <button ejs-button cssClass="e-btn e-primary custom-btn" [disabled]="isBusy()" (click)="stay()">
            {{ t('Stay') }}
          </button>
        }
        <button ejs-button cssClass="e-btn e-primary custom-btn" [disabled]="isBusy()" (click)="switch()">
          {{ t('Switch') }}
        </button>
      </div>
    </ng-template>
  </ejs-dialog>
</ng-container>
